import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/pro-regular-svg-icons";
import { FormattedDate } from "../common";
import { NextJourneyDto } from "../../types/journeys/NextJourney";

interface NextJourneyProps {
  journey: NextJourneyDto;
}

function NextJourney({ journey }: NextJourneyProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center bg-white rounded-lg p-4 mt-2 border border-gray-200 shadow-sm gap-3 sm:gap-0">
      <div className="flex items-center gap-3">
        <div className="text-primary">
          <FontAwesomeIcon icon={faCalendar} className="w-6 h-6" />
        </div>
        <h4 className="text-primary font-medium text-lg">
          Your next scheduled journey
        </h4>
      </div>

      <div className="flex flex-col sm:items-end">
        <span className="font-medium">{journey.title}</span>
        {journey.expectedStartDate && (
          <span className="text-gray-500 text-sm">
            <FormattedDate
              date={new Date(journey.expectedStartDate)}
              displayMode="FROM-NOW"
            />
          </span>
        )}
      </div>
    </div>
  );
}

export default NextJourney;
